import { forwardRef, TextareaHTMLAttributes } from "react"
import { classNames } from "utils/ClassNames"

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean
}

const textareaBase =
  "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm/6 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-500"

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { hasError = false, className, ...props },
  ref
) {
  const ringClasses = hasError
    ? "ring-red-300 focus:ring-red-500 dark:ring-red-500/60"
    : "ring-gray-300 focus:ring-primary-600 dark:ring-gray-600 dark:focus:ring-primary-500"

  return (
    <textarea
      ref={ref}
      className={classNames(textareaBase, ringClasses, className)}
      {...props}
    />
  )
})
